import OrderStatusCard from '@/home/OrderStatusCard/OrderStatusCard';
import { FeedItemType } from '~/constants/home';
import { BffFeedItem } from '~/contracts/home';
import ErrorBoundary from '~/utilities/ErrorBoundary';

export enum StatusCardType {
  Order,
  PurchaseInProgress,
  Purchased,
  Reserved
}

export default function feedItemMapper(feedItem: BffFeedItem) {
  let cardType: StatusCardType;

  switch (feedItem.type) {
    case FeedItemType.RETAIL_ORDER_PLACED:
    case FeedItemType.TRADE_ORDER_PLACED:
      cardType = StatusCardType.Order;
      break;

    case FeedItemType.RETAIL_PURCHASE_IN_PROGRESS:
    case FeedItemType.TRADE_PURCHASE_IN_PROGRESS:
      cardType = StatusCardType.PurchaseInProgress;
      break;

    case FeedItemType.PURCHASE_POST_DELIVERY_0_7:
    case FeedItemType.PURCHASE_POST_DELIVERY_8_100:
      cardType = StatusCardType.Purchased;
      break;

    case FeedItemType.RETAIL_PREORDER:
      cardType = StatusCardType.Reserved;
      break;

    default:
      return null;
  }

  return (
    <ErrorBoundary key={feedItem.type}>
      <OrderStatusCard cardStatus={cardType} feedItem={feedItem} />
    </ErrorBoundary>
  );
}
